import { useState, useCallback } from 'react';
import { ToastMessage } from '../components/CollaborationToast';

export const useCollaborationToast = () => {
  const [messages, setMessages] = useState<ToastMessage[]>([]);

  const showToast = useCallback((
    message: string, 
    type: 'info' | 'warning' | 'success' = 'info',
    duration: number = 5000
  ) => {
    const id = Math.random().toString(36).substr(2, 9);
    const newMessage: ToastMessage = {
      id,
      message,
      type,
      duration
    };

    setMessages(prev => [...prev, newMessage]);
    return id;
  }, []);

  const dismissToast = useCallback((id: string) => {
    setMessages(prev => prev.filter(msg => msg.id !== id));
  }, []);

  const clearAllToasts = useCallback(() => {
    setMessages([]);
  }, []);

  // 專門用於協作提醒的便捷函數
  const showCollaborationAlert = useCallback((editorName: string, action: string = '修改了資料') => {
    return showToast(
      `🤝 ${editorName} 剛剛${action}`,
      'warning',
      6000 // 協作提醒顯示較久
    );
  }, [showToast]);

  const showCollaborationSuccess = useCallback((message: string) => {
    return showToast(message, 'success', 4000);
  }, [showToast]);

  return {
    messages,
    showToast,
    showCollaborationAlert,
    showCollaborationSuccess,
    dismissToast,
    clearAllToasts
  };
};